import { IListBrandOrderGroupFiltersRequest } from "@faire/web-api--source/indigofair/data/IListBrandOrderGroupFiltersRequest";
import { IListBrandOrderGroupsRequest } from "@faire/web-api--source/indigofair/data/IListBrandOrderGroupsRequest";
import { IPaginationData } from "@faire/web-api--source/indigofair/data/IPaginationData";
import { QueryParameters as OrdersParams } from "@faire/web-api--source/routes/www/orders";

import { BO_GROUP_LIST_PAGE_SIZE } from "./consts";

export const getBrandOrderGroupsRequest = (queryParams: OrdersParams) => {
  return IListBrandOrderGroupsRequest.build({
    query: queryParams.query,
    filter_keys: queryParams.filters?.split(",").sort(),
    action_required_only: false,
    pagination_data: IPaginationData.build({
      page_number: Number(queryParams.page ?? 1),
      page_size: BO_GROUP_LIST_PAGE_SIZE,
    }),
  });
};

export const getBrandOrderGroupsFiltersRequest = (
  queryParams: OrdersParams
) => {
  return IListBrandOrderGroupFiltersRequest.build({
    list_brand_order_groups_request: IListBrandOrderGroupsRequest.build({
      ...getBrandOrderGroupsRequest(queryParams),
      pagination_data: IPaginationData.build(),
    }),
  });
};

export const getActionRequiredGroupsRequest = () => {
  return IListBrandOrderGroupsRequest.build({
    action_required_only: true,
  });
};
